$(document).ready(function () {
    checkShopTheLook();
    if (!$('body').hasClass('template-cart')) {
        refreshMiniCart()
    } else {
        document.cookie = 'dynamic_checkout_shown_on_cart=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    $(document).on('click', '.top-cart', function () {
        $(this).closest('.wrapper-top-cart').addClass('active');
        $('body').addClass('no-scroll');
    });
    $(document).on('click', '.title-cart #close-cart, #overlay-bg, .cart-continue', function (e) {
        $('.wrapper-top-cart').removeClass('active');
        $('body').removeClass('no-scroll');
        e.preventDefault();
    });

    // Quantity
    $(document).on('click', '.product-quantity-items .product-minus', function () {
        var qty = parseInt($(this).parent('.product-quantity-items').find('.qty').val());
        qty = qty - 1;
        $(this).next('.qty').val(qty).trigger('change');
    });
    $(document).on('click', '.product-quantity-items .product-plus', function () {
        var qty = parseInt($(this).parent('.product-quantity-items').find('.qty').val());
        qty = qty + 1;
        $(this).prev('.qty').val(qty).trigger('change');
    });
    $(document).on('change', '.qty', function () {
        var id = $(this).data('id');
        var qty = parseInt($(this).val());
        $('.wrapper-top-cart #toggle-cart-slide .ajax-loader').show();

        if (qty == 0) {
            var p_id = $(this).closest('.product-details').find('.btn-remove').data('product-id');
            $.cookie(p_id, null)
        }

        $.ajax({
            method: "POST",
            url: "/cart/update.js",
            data: "updates[" + id + "]=" + qty,
            dataType: "json",
            success: function (response) {
                refreshMiniCart();
            },
            error: function (XMLHttpRequest, textStatus) {
                $('.wrapper-top-cart #toggle-cart-slide .ajax-loader').hide();
                handleError(XMLHttpRequest);
            }
        });
    });
    $(document).on('click', '.remove-cart .btn-remove', function () {
        //$('#close-cart').trigger('click');
        var id = $(this).data('id');
        var p_id = $(this).data('product-id');

        if (id) {
            $('.wrapper-top-cart #toggle-cart-slide .ajax-loader').show();
            $.ajax({
                method: "POST",
                url: "/cart/update.js",
                data: "updates[" + id + "]=0",
                dataType: "json",
                success: function (response) {
                    //console.log();
                    if (response['item_count'] == 0) {
                        $('#close-cart').trigger('click');
                    }
                    console.log(p_id);
                    $.cookie(p_id, null)
                    refreshMiniCart();
                },
                error: function (XMLHttpRequest, textStatus) {
                    $('.wrapper-top-cart #toggle-cart-slide .ajax-loader').hide();
                    handleError(XMLHttpRequest);
                }
            });
        }
    });
    if ($('.mini-products .product-list-item li').length > 0) {
        initUpsellProductOwl();
    }
    ;


    $(document).on('click', '.mini-products .list-option a:not(.disabled)', function (e) {
        e.preventDefault();
        $(this).closest('.list-option').find('.active').removeClass('active');
        $(this).addClass('active');
        $('.mini-products .has-variant').removeAttr("disabled");
    });

    $(document).on('click', '#toggle-cart-slide .mini-products .product-list-item .actions .btn', function (e) {
        e.preventDefault();
    });
    $(document).on('click', '#toggle-cart-slide .buy-area .btn', function (e) {
        e.preventDefault();
        if ($('#terms').prop('checked')) {
            window.location = '/checkout'
        } else {
            $('.terms-conditions').addClass('error')
            setTimeout(function () {
                $('.terms-conditions').removeClass('error')
            }, 2000)
        }
    });


});
/* MINICART FUNCTIONS */

//reinit minicart
function refreshMiniCart(lineitem, quantity) {
    if ($('body').hasClass('template-cart')) {
        window.location.reload();
    } else {
        $.ajax({
            method: "GET",
            url: "/cart",
            data: {"view": "ajax"},
            xhrFields: {
                withCredentials: true
            },
            dataType: 'html',
            success: function (response) {
                //console.log(response);
                var CartCount = $(response).find('#cartCount').html();
                //console.log(CartCount);
                var contentCartHtml = $(response).find('#toggle-cart-slide').html();
                //console.log(contentCartHtml);
                if (CartCount) {
                    $('#cartCount').text(CartCount);
                    $('#fixcartCount').text(CartCount);
                }
                if (contentCartHtml) {
                    $('#toggle-cart-slide').html(contentCartHtml);
                }
                //console.log($('.mini-products .product-list-item li').length);
                if ($('.mini-products .product-list-item li').length > 0) {
                    initUpsellProductOwl();
                }
            }
        });
    }
}

function checkShopTheLook() {
    var count = 0;
    $('.mini-products .wrap-product-list-item').each(function (i) {
        var id = $(this).attr('data-id');

        if (document.cookie.indexOf(id) < 0) {
            if (count == 0) {
                $('#' + id).addClass('active');
            }
            count = count + 1;

        } else {
            $('#' + id).addClass('removed');
        }

    });
}

function initUpsellProductOwl() {


    $('.hide-product-list-item').on('click', function (e) {
        $(this).parent().removeClass('active');
        var id = $(this).parent().attr('data-id');
        $.cookie(id, 'removed', {expires: 1});
        checkShopTheLook();
    });

    $('.mini-products .product-list-item').each(function () {
        $(this).owlCarousel({
            items: 1,
            itemsDesktop: [1199, 1],
            itemsDesktopSmall: [979, 1],
            itemsTablet: [768, 1],
            itemsTabletSmall: [540, 1],
            itemsMobile: [360, 1],
            autoPlay: 5000
        });
    });
    checkShopTheLook();

}

$(document).ready(function () {
    if (changeImageZip) {
        setInterval(changeImageZip, 1000);
    }

    function changeImageZip() {
        $('.zipmoney .zip-widget img').attr('src', 'https://cdn.shopify.com/s/files/1/0044/7263/5463/files/zip_2x_382403c7-c1e6-46d0-b48d-2b4708b61b0e.png?v=1639130863');
        $('.zipmoney .zip-widget .logo').css('display', 'block');
        clearInterval(changeImageZip)
    }
});

// function calcMaxHeightCartContent() {
//   var windowHeight = $(window).height();
//   var headerHeight = $('.site-header').height();

//   // 201 is total height of minicart title and minicart bottom part
//   var maxHeightDropdownContent = windowHeight - headerHeight - 456;
//   var maxHeightSlideoutContent = windowHeight - 456;
//   // check if max height > 20 enough to touch and < 318 that styled in css file
//   if (maxHeightDropdownContent > 20 && maxHeightDropdownContent < 318) {
//     $('.wrapper-top-cart #toggle-cart-slide .products-list-items').css('max-height', maxHeightDropdownContent);
//   } else {
//     $('.wrapper-top-cart #toggle-cart-slide .products-list-items').css('max-height', '');
//   }
//   if (maxHeightSlideoutContent > 20) {
//     $('.wrapper-top-cart #toggle-cart-slide .products-list-items').css('max-height', maxHeightSlideoutContent);
//   } else {
//     $('.wrapper-top-cart #toggle-cart-slide .products-list-items').css('max-height', '');
//   }
// }
// // init on first load
// calcMaxHeightCartContent();
// $(window).on('resize', function() {
//   // reinit on resize
//   setTimeout(function() {
//     calcMaxHeightCartContent();
//   }, 300);
// });
